import { ServiceControllerStatus } from "../../../typings/board/ServiceProcess";

export function serviceStatusFilter() {
    return function (input: ServiceControllerStatus) {
        switch (input) {
            case ServiceControllerStatus.ContinuePending:
                return "Continue pending";
            case ServiceControllerStatus.Paused:
                return "Paused";
            case ServiceControllerStatus.PausePending:
                return "Pause pending";
            case ServiceControllerStatus.Running:
                return "Running";
            case ServiceControllerStatus.StartPending:
                return "Start pending";
            case ServiceControllerStatus.Stopped:
                return "Stopped";
            case ServiceControllerStatus.StopPending:
                return "Stop pending";
        }
    }
}


// WEBPACK FOOTER //
// ./app/common/filters/service-status.filter.ts